import QRModal from './components/QRModal'
import EmployeeCard from './components/EmployeeCard'
import StaffModal from './components/StaffModal'
import Input from 'features/common/components/Input'
import add from 'assets/add.svg'
import DeleteModal from './components/DeleteModal'
import SortSelect from './components/SortSelect'
import Spinner from 'features/common/components/Spinner'
import useEmployeesQRPage from '../../../common/hooks/useEmployeesQRPage'

const EmployeesQR = () => {
    const {
        data: {isLoading, map, filteredAndSortedIds},
        filter: {filterBy, onFilter},
        sort: {sortBy, onSort},
        editModal: {
            isEditModalOpen,
            editModalInitialData,
            openEditModalWithData,
            openEditModal,
            closeEditModal,
        },
        qrModal: {qrModalOptions, onOpenQRModal, onCloseQRModal},
        deleteModal: {
            deleteModalOptions,
            onOpenDeleteModal,
            onCloseDeleteModal,
        },
    } = useEmployeesQRPage()

    if (isLoading) {
        return (
            <div className="flex items-center justify-center pt-12">
                <Spinner className="w-16" yellow />
            </div>
        )
    }

    return (
        <div className="flex min-h-0 flex-1 flex-col pb-14">
            <div className="mb-2 flex items-center gap-2">
                <Input
                    value={filterBy}
                    onChange={onFilter}
                    className="h-8 flex-1 border text-sm"
                    placeholder="Search"
                />
                <button className="col-span-1 flex items-center justify-center">
                    <img
                        className="h-12 w-12"
                        src={add}
                        alt="add"
                        onClick={openEditModal}
                    />
                </button>
            </div>
            <div className="mb-6 flex">
                <div className="flex flex-1">
                    <SortSelect sortBy={sortBy} onSort={onSort} />
                </div>
            </div>
            <div className="flex flex-1 flex-col gap-5 overflow-y-auto">
                {filteredAndSortedIds.map((eId, idx) => (
                    <EmployeeCard
                        key={idx}
                        onEdit={openEditModalWithData}
                        onOpenQR={onOpenQRModal}
                        employee={map[eId]}
                    />
                ))}
            </div>
            {isEditModalOpen && (
                <StaffModal
                    initialData={editModalInitialData}
                    onDelete={onOpenDeleteModal}
                    onClose={closeEditModal}
                />
            )}
            {qrModalOptions && (
                <QRModal employee={qrModalOptions} onClose={onCloseQRModal} />
            )}
            {deleteModalOptions && (
                <DeleteModal
                    employee={deleteModalOptions}
                    onClose={onCloseDeleteModal}
                />
            )}
        </div>
    )
}
export default EmployeesQR
